import { render, staticRenderFns } from "./uploadVersion.vue?vue&type=template&id=342a7cc0&"
import script from "./uploadVersion.vue?vue&type=script&lang=js&"
export * from "./uploadVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports